import React, { useState, useEffect } from 'react'

// css
import 'assets/style/elements/input-search.scss'

// element
import TextInput from 'components/elements/TextInput'
import IconButton from 'components/elements/IconButton'

function Element({
  value,
  className = '',
  placeholder = '입력하세요.',
  disabled = false,
  onChange = () => {},
  onClick = () => {},
}) {
  return (
    <>
      <div className="flex pd0">
        <TextInput
          placeholder={placeholder}
          className={'b-none ' + className}
          value={value}
          diabled={disabled}
          onChange={onChange}
          onKeyUp={(e) => {
            if (e.key === 'Enter') onClick()
          }}
        />
        <IconButton
          type="search"
          size="40"
          onClick={() => onClick()}
          style={{
            border: '0px solid #dbdbdb',
            borderWidth: '1px 1px 1px 0px',
          }}
        />
      </div>
    </>
  )
}

export default Element
